export const ADD_TO_RECENT_SEARCHES = 'ADD_TO_RECENT_SEARCHES';
export const addToRecentSearches = (query) => ({
	type: ADD_TO_RECENT_SEARCHES,
	query,
});
